import { cva } from 'class-variance-authority';

const button = cva('', {
    variants: {
        size: {
            normal: ['btn'],
            large: ['btn-lg'],
        },
        type: {
            primary: ['btn-primary'],
            white: ['btn-white'],
            yes: ['btn-yes'],
            no: ['btn-no'],
        },
    },
    defaultVariants: {
        type: 'primary',
        size: 'normal',
    },
});
const Button = ({ type, children, onClick, disabled, ...props }) => {
    const { title, action, fn } = props;

    // if (children) {
    //     return (
    //         <button className={button({ type })} onClick={() => fn.handleButton(action)}>
    //             {children}
    //         </button>
    //     );
    // }

    // return (
    //     <button className={button({ type })} onClick={() => fn.handleButton(action)}>
    //         {children ?? title}
    //     </button>
    // );
    return (
        <button 
        className={`${button({ type })} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`} 
        disabled={disabled} 
        onClick={onClick} 
        {...props}>
            {children ?? title}
        </button>
    );
};

export default Button;
